import { PublicLayout } from "@/components/public/PublicLayout";

const LAST_UPDATE = "juin 2026";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-display text-xl font-bold text-slate-900">{title}</h2>
      <div className="mt-3 space-y-3 text-slate-700 leading-relaxed">{children}</div>
    </section>
  );
}

export function MentionsLegales() {
  return (
    <PublicLayout>
      <div data-testid="mentions-legales-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <h1 className="font-display text-3xl font-bold text-slate-900">Mentions légales</h1>
        <p className="text-sm text-slate-500 mt-2">Dernière mise à jour : {LAST_UPDATE}</p>

        <Section title="Éditeur du site">
          <p>
            Le site <strong>ASSURE CONSEIL</strong> est édité par la société <strong>EDEAL</strong>,
            société par actions simplifiée (SAS) au capital de 2 500 €.
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Marque commerciale :</strong> ASSURE CONSEIL</li>
            <li><strong>Dénomination sociale :</strong> EDEAL</li>
            <li><strong>Forme juridique :</strong> SAS, société par actions simplifiée</li>
            <li><strong>Capital social :</strong> 2 500 €</li>
            <li><strong>Siège social :</strong> 313A avenue Marcel Mérieux, 69530 Brignais, France</li>
            <li><strong>SIREN :</strong> 812 877 991</li>
            <li><strong>SIRET (siège) :</strong> 812 877 991 00024</li>
            <li><strong>RCS :</strong> Lyon 812 877 991</li>
            <li><strong>Code APE / NAF :</strong> 66.22Z — Activités des agents et courtiers d'assurances</li>
            <li><strong>E-mail :</strong> contact@assureconseil.com</li>
          </ul>
        </Section>

        <Section title="Directeur de la publication">
          <p>M. MDALLEL, représentant légal de la société EDEAL.</p>
        </Section>

        <Section title="Immatriculation et activité de courtage">
          <p>
            EDEAL exerce une activité de courtage en assurances. La société est immatriculée au
            Registre unique des intermédiaires en assurance, banque et finance (ORIAS) sous le
            numéro <strong>15004995</strong>.
          </p>
          <p>
            Vous pouvez vérifier cette immatriculation sur le site de l'ORIAS :{" "}
            <a href="https://www.orias.fr" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">www.orias.fr</a>.
          </p>
        </Section>

        <Section title="Autorité de contrôle">
          <p>
            L'activité de courtage en assurances est soumise au contrôle de l'Autorité de Contrôle
            Prudentiel et de Résolution (ACPR) — 4 Place de Budapest, CS 92459, 75436 Paris Cedex 09 —{" "}
            <a href="https://acpr.banque-france.fr" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">acpr.banque-france.fr</a>.
          </p>
        </Section>

        <Section title="Médiation">
          <p>
            En cas de litige non résolu avec nos services, vous pouvez saisir gratuitement le médiateur
            de l'assurance : La Médiation de l'Assurance — TSA 50110, 75441 Paris Cedex 09 —{" "}
            <a href="https://www.mediation-assurance.org" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">www.mediation-assurance.org</a>.
          </p>
        </Section>

        <Section title="Hébergement du site">
          <p>
            Le site est hébergé par <strong>OVH</strong> — OVH SAS, 2 rue Kellermann, 59100 Roubaix,
            France —{" "}
            <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">www.ovhcloud.com</a>.
          </p>
        </Section>

        <Section title="Propriété intellectuelle">
          <p>
            L'ensemble des contenus présents sur ce site (textes, visuels, logos, marques, architecture)
            est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive
            d'EDEAL ou de ses partenaires. Toute reproduction ou représentation, totale ou partielle,
            sans autorisation préalable est interdite.
          </p>
        </Section>

        <Section title="Responsabilité">
          <p>
            Ce site a une vocation d'information et de mise en relation. Les informations présentées ne
            constituent pas un conseil contractuel et aucune offre n'est présentée comme un contrat réel
            sans validation préalable d'un conseiller habilité. EDEAL s'efforce d'assurer l'exactitude
            des informations diffusées mais ne saurait être tenue responsable des erreurs ou omissions.
          </p>
        </Section>
      </div>
    </PublicLayout>
  );
}

export function Confidentialite() {
  return (
    <PublicLayout>
      <div data-testid="confidentialite-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <h1 className="font-display text-3xl font-bold text-slate-900">Politique de confidentialité</h1>
        <p className="text-sm text-slate-500 mt-2">Dernière mise à jour : {LAST_UPDATE}</p>

        <Section title="Responsable du traitement">
          <p>
            Le responsable du traitement des données collectées sur ce site est la société{" "}
            <strong>EDEAL</strong> (marque ASSURE CONSEIL), 313A avenue Marcel Mérieux, 69530 Brignais —
            e-mail : contact@assureconseil.com.
          </p>
        </Section>

        <Section title="Données collectées">
          <p>
            Nous collectons uniquement les données nécessaires au traitement de votre demande de
            comparaison et à votre accompagnement par un conseiller : réponses au simulateur, numéro de
            téléphone, nom, préférences et historique d'échanges.
          </p>
        </Section>

        <Section title="Finalités du traitement">
          <p>
            Vos données sont traitées pour : l'étude de votre besoin et l'établissement de comparatifs,
            la prise de contact et l'accompagnement commercial, l'établissement de devis et la gestion de
            la relation client. La vérification de votre numéro de téléphone sert exclusivement à
            sécuriser l'accès à votre comparatif et ne constitue pas un consentement à recevoir des
            publicités.
          </p>
        </Section>

        <Section title="Base légale">
          <p>
            Les traitements reposent sur votre consentement, sur l'exécution de mesures précontractuelles
            prises à votre demande et sur l'intérêt légitime d'EDEAL à développer et gérer son activité
            de courtage.
          </p>
        </Section>

        <Section title="Durée de conservation">
          <p>
            Vos données sont conservées pendant la durée nécessaire au traitement de votre demande, puis
            archivées ou supprimées conformément aux durées légales applicables au secteur de
            l'assurance.
          </p>
        </Section>

        <Section title="Destinataires">
          <p>
            Vos données sont destinées aux équipes habilitées d'EDEAL et, le cas échéant, aux compagnies
            d'assurance et partenaires strictement nécessaires à l'établissement de votre devis. Elles ne
            sont jamais vendues à des tiers.
          </p>
        </Section>

        <Section title="Sécurité">
          <p>
            Vos données sont stockées de manière sécurisée. Les mots de passe ne sont jamais conservés en
            clair et les identifiants techniques restent protégés côté serveur.
          </p>
        </Section>

        <Section title="Vos droits">
          <p>
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
            Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement,
            d'opposition, de limitation et de portabilité de vos données. Les communications commerciales
            respectent vos préférences et comportent un mécanisme de désinscription.
          </p>
          <p>
            Pour exercer vos droits, contactez-nous à l'adresse contact@assureconseil.com. Vous disposez
            également du droit d'introduire une réclamation auprès de la CNIL —{" "}
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">www.cnil.fr</a>.
          </p>
        </Section>

        <Section title="Cookies">
          <p>
            Le site peut utiliser des cookies strictement nécessaires à son bon fonctionnement ainsi que,
            sous réserve de votre consentement, des cookies de mesure d'audience. Vous pouvez configurer
            votre navigateur pour refuser les cookies non essentiels.
          </p>
        </Section>
      </div>
    </PublicLayout>
  );
}
